import { useEffect } from "react";
import "./hanziRecallPrivacy.css";

export default function HanziRecallPrivacyPage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Hanzi Blitz Privacy & Support";

    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <main className="hanziPrivacyPage">
      <article className="hanziPrivacyCard">
        <a className="hanziPrivacyBack" href="/hanzi-blitz">← Hanzi Blitz</a>
        <header className="hanziPrivacyHeader">
          <div className="hanziPrivacyBrand" aria-hidden="true">字</div>
          <div>
            <p className="hanziPrivacyEyebrow">Hanzi Blitz</p>
            <h1>Privacy Policy &amp; Support</h1>
            <p className="hanziPrivacyEffective">Effective August 19, 2026</p>
          </div>
        </header>

        <section aria-labelledby="privacy-summary">
          <h2 id="privacy-summary">Your learning stays on your device</h2>
          <p>
            Hanzi Blitz is designed to work offline. It does not collect,
            transmit, sell, or share personal data.
          </p>
        </section>

        <section aria-labelledby="stored-data">
          <h2 id="stored-data">Data stored on your iPhone</h2>
          <p>
            The app stores study progress, review history, learned-word status,
            hidden-word choices, and app settings locally on your iPhone. This
            information is used only to schedule reviews and display your
            statistics. It is not sent to the developer or any third party.
          </p>
          <p>
            Hanzi Blitz does not include accounts, advertising, analytics,
            tracking technologies, or third-party software development kits.
          </p>
        </section>

        <section aria-labelledby="audio">
          <h2 id="audio">Pronunciation audio</h2>
          <p>
            Pronunciation playback uses Apple&apos;s system speech-synthesis service.
            Hanzi Blitz does not record audio and does not request microphone
            access.
          </p>
        </section>

        <section aria-labelledby="deleting-data">
          <h2 id="deleting-data">Deleting your data</h2>
          <p>
            You can erase study data from the app&apos;s Settings screen using
            “Reset all progress.” Deleting the app also removes its locally
            stored data.
          </p>
        </section>

        <section aria-labelledby="children">
          <h2 id="children">Children&apos;s privacy</h2>
          <p>
            Because Hanzi Blitz does not collect personal data, it does not
            knowingly collect personal information from children.
          </p>
        </section>

        <section aria-labelledby="changes">
          <h2 id="changes">Changes to this policy</h2>
          <p>
            If the app&apos;s data practices change, this policy and the App Store
            privacy disclosure will be updated before the changed version is
            released.
          </p>
        </section>

        <section className="hanziPrivacySupport" aria-labelledby="support">
          <h2 id="support">Support</h2>
          <p>
            For privacy questions, app support, or feedback, contact Heng Quan.
          </p>
          <a href="mailto:henryquan.tum@gmail.com">
            henryquan.tum@gmail.com
          </a>
        </section>

        <footer className="hanziPrivacyFooter">
          © 2026 Heng Quan. Hanzi Blitz.
        </footer>
      </article>
    </main>
  );
}
